<template>
  <div class="center">
    <!-- <h1>{{ this.$parent.$parent.$children[0].pageType }}-公告考生管理</h1> -->
    <!-- 条件筛选框 -->
    <div class="waitingcom_title">
      <!-- 表单 -->
      <el-form
        label-width="80px"
        :model="formLabelAlign"
        ref="formLabelAlign"
        :label-position="labelPosition"
      >
        <el-form-item label="考生姓名：">
          <el-input
            v-model.trim="formLabelAlign.RealName"
            placeholder="请输入考生姓名"
          ></el-input
        ></el-form-item>

        <el-form-item label="考生账号：">
          <el-input
            v-model.trim="formLabelAlign.UserName"
            placeholder="请输入考生账号"
          ></el-input
        ></el-form-item>

        <el-form-item label="科室：" v-if="departmentAuth">
          <el-select
            v-model="formLabelAlign.DepartmentName"
            placeholder="全部"
            @change="handleQuery"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in departmentList"
              :key="item.departmentid"
              :label="item.DepartmentName"
              :value="item.DepartmentName"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="职称：">
          <el-select
            v-model="formLabelAlign.PTitle"
            placeholder="全部"
            @change="handleQuery"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in pTitleList"
              :key="item.PTitle"
              :label="item.PTitle"
              :value="item.PTitle"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="用户组：">
          <el-select
            v-model="formLabelAlign.groupID"
            placeholder="全部"
            @change="handleQuery"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in groupList"
              :key="item.groupID"
              :label="item.groupName"
              :value="item.groupID"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 搜索按钮 -->
      <div class="query_btn">
        <el-button
          @click="handleQuery"
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          >搜索</el-button
        >
        <el-button
          @click="resetQuery"
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          >重置</el-button
        >
      </div>
    </div>

    <!-- 列表全局按钮 -->
    <div
      class="oper_box"
      v-if="this.$parent.$parent.$children[0].pageType === 'add'"
    >
      <el-button @click="addMember" plain
        ><i class="iconfont icon-action-add-hover"></i>添加考生</el-button
      >
    </div>

    <!-- 表格内容 -->
    <div class="student_table">
      <el-table
        ref="table"
        :data="getData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @row-click="stepsListRowClick"
        :row-key="getRowKeyOfTarget"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
        v-loading="isLoading"
      >
        <el-table-column label="序号" type="index" width="100" align="center"
          ><template slot-scope="scope">
            <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="考生账号" align="center">
          <template slot-scope="scope">
            {{ scope.row.UserName }}
          </template>
        </el-table-column>

        <el-table-column label="考生姓名" align="center">
          <template slot-scope="scope">
            {{ scope.row.RealName }}
          </template>
        </el-table-column>

        <el-table-column label="账户类型" align="center">
          <template slot-scope="scope">
            {{ scope.row.UserTypeCN }}
          </template>
        </el-table-column>

        <el-table-column label="科室名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.DepartmentName }}
          </template>
        </el-table-column>

        <el-table-column label="职称" align="center">
          <template slot-scope="scope">
            {{ scope.row.PTitle }}
          </template>
        </el-table-column>

        <el-table-column label="职位" align="center">
          <template slot-scope="scope">
            {{ scope.row.Position }}
          </template>
        </el-table-column>

        <el-table-column label="出生年月日" align="center">
          <template slot-scope="scope">
            {{
              scope.row.Birthday == null
                ? null
                : $moment(scope.row.Birthday).format("YYYY-MM-DD")
            }}
          </template>
        </el-table-column>

        <el-table-column label="工作年限" align="center">
          <template slot-scope="scope">
            {{ scope.row.JobDate }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="foot_box">
      <div class="foot_pagetions">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :page-sizes="pagesizesArr"
          layout="prev, pager, next, sizes, jumper"
          :total="total"
          class="pagination"
        ></el-pagination>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="operation">
      <el-button class="succ_btn" @click="prevPage">上一页</el-button>
      <el-button
        :disabled="sumbitBtnDisable"
        type="success"
        class="submit_btn"
        @click="switchSubmitBtn"
        >{{
          this.$parent.$parent.$children[0].pageType | sumbitBtnName
        }}</el-button
      >
    </div>

    <!-- 添加考生 -->
    <AddMember ref="addMember" />

    <div class="konghuang"></div>
  </div>
</template>

<script>
import noticeApi from "@/api/notice";
import AddMember from "./AddMember";
export default {
  props: ["cutcoms"],
  components: {
    AddMember,
  },
  data() {
    return {
      // 条件筛选框全局定义
      labelPosition: "right",
      formLabelAlign: {
        RealName: "",
        UserName: "",
        DepartmentName: "",
        PTitle: "",
        groupID: "",
      },
      departmentList: [],
      positionList: [],
      pTitleList: [],
      groupList: [],
      departmentAuth: true,
      // 表格内容全局定义
      allDataIds: [],
      allData: [],
      isLoading: false,
      multipleSelectionIds: [],
      multipleSelection: [],
      multipleSelectionCount: 0,
      getDataCondition: {
        RealName: "",
        UserName: "",
        DepartmentName: "",
        PTitle: "",
        groupID: "",
      },
      getData: [],
      currentPage: 1,
      pageSize: 10,
      pagesizesArr: [5, 10, 20, 50, 100],
      total: 0,
      // 确定添加按钮
      sumbitBtnDisable: false,
    };
  },
  methods: {
    // 条件筛选按钮
    handleQuery() {
      this.$refs.table.clearSelection();
      this.currentPage = 1;
      if (this.formLabelAlign.RealName) {
        this.getDataCondition.RealName = this.formLabelAlign.RealName;
      } else {
        this.getDataCondition.RealName = "";
      }
      if (this.formLabelAlign.UserName) {
        this.getDataCondition.UserName = this.formLabelAlign.UserName;
      } else {
        this.getDataCondition.UserName = "";
      }
      if (this.formLabelAlign.DepartmentName) {
        this.getDataCondition.DepartmentName =
          this.formLabelAlign.DepartmentName;
      } else {
        this.getDataCondition.DepartmentName = "";
      }
      if (this.formLabelAlign.PTitle) {
        this.getDataCondition.PTitle = this.formLabelAlign.PTitle;
      } else {
        this.getDataCondition.PTitle = "";
      }
      if (this.formLabelAlign.groupID) {
        this.getDataCondition.groupID = this.formLabelAlign.groupID;
      } else {
        this.getDataCondition.groupID = "";
      }
      this.switchLists();
    },
    resetQuery() {
      this.formLabelAlign = {
        RealName: "",
        UserName: "",
        DepartmentName: "",
        PTitle: "",
        groupID: "",
      };
      this.$refs.table.clearSelection();
      this.currentPage = 1;
      this.getDataCondition.RealName = "";
      this.getDataCondition.UserName = "";
      this.getDataCondition.DepartmentName = "";
      this.getDataCondition.PTitle = "";
      this.getDataCondition.groupID = "";
      this.switchLists();
    },
    // 基本请求参数工具
    baseReqParamUtils(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
    // 获取分组列表
    async groupLists() {
      const reqParam = this.baseReqParamUtils(new Object());
      console.log(reqParam, "获取分组列表请求数据");
      const { data } = await noticeApi.groupList(reqParam);
      console.log(data, "获取分组列表响应数据");
      if (data.Status == 200) {
        this.groupList = data.Data.data;
      } else {
        this.$message.error(data.Data);
      }
    },
    switchLists() {
      const pageType = this.$parent.$parent.$children[0].pageType;
      switch (pageType) {
        case "add":
          this.getSectionInfos();
          this.getPTitleInfos();
          this.getStudentLists();
          break;
        case "edit":
          break;
        case "detail":
          this.getSectionInfos();
          this.getPTitleInfos();
          this.noticePreviews();
          break;
        default:
          this.$message.error("没有找到页面类型");
          return;
      }
    },
    // 查询科室列表
    async getSectionInfos() {
      const reqParam = this.baseReqParamUtils(new Object());
      console.log(reqParam, "查询科室列表请求数据");
      const { data } = await noticeApi.getSectionInfo(reqParam);
      console.log(data, "查询科室列表响应数据");
      if (data.Status == 200) {
        this.departmentList = data.Data;
      } else if (data.Status == 202) {
        this.departmentAuth = false;
      } else {
        this.$message.error(data.Msg);
      }
    },
    // 查询职称列表
    async getPTitleInfos() {
      const reqParam = this.baseReqParamUtils(new Object());
      console.log(reqParam, "查询职称列表请求数据");
      const { data } = await noticeApi.getPTitleInfo(reqParam);
      console.log(data, "查询职称列表响应数据");
      this.pTitleList = data;
    },
    // 查看考生列表
    async noticePreviews() {
      this.isLoading = true;
      const reqParam = this.baseReqParamUtils(new Object());
      reqParam.pageIndex = this.currentPage - 1;
      reqParam.eachPageNum = this.pageSize;
      reqParam.NoticeID = this.$parent.$parent.$children[0].rowData.NoticeID;

      reqParam.realName = this.getDataCondition.RealName;
      reqParam.userName = this.getDataCondition.UserName;
      reqParam.department = this.getDataCondition.DepartmentName;
      reqParam.job = this.getDataCondition.PTitle;
      reqParam.groupID = this.getDataCondition.groupID;

      console.log(reqParam, "@@@查看考生列表请求数据");
      const { data } = await noticeApi.noticePreview(reqParam);
      console.log(data, "@@@查看考生列表响应数据");
      if (data.Status == 200) {
        this.getData = data.Data.userArr[0];
        this.total = data.Data.userArr[1][0].dataCount;
        this.isLoading = false;
      } else {
        this.$message.error(data.Msg);
      }
    },
    // 获取考生列表
    async getStudentLists() {
      this.getData = [];
      let start = (this.currentPage - 1) * this.pageSize;
      for (let index = start; index < this.allData.length; index++) {
        const element = this.allData[index];
        if (index == start + this.pageSize) {
          break;
        }
        this.getData.push(element);
      }
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 表格多选框改变时触发
    handleSelectionChange(rows) {
      // 初始化全局表格多选框
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      // 将数据存入
      rows.forEach((row) => {
        this.multipleSelectionIds.push(row.UserID);
      });
      this.multipleSelection = rows;
      this.multipleSelectionCount = this.multipleSelection.length;
      // 全局按钮样式配置
      this.multiple = !this.multipleSelection.length;
    },
    // 勾选当前行激活check
    stepsListRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.UserID;
    },
    // 每页大小改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.switchLists();
    },
    // 切换页数后触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.switchLists();
    },
    // 上一页
    prevPage() {
      this.cutcoms(0);
    },
    // 底部按钮开关
    switchSubmitBtn() {
      const pageType = this.$parent.$parent.$children[0].pageType;
      switch (pageType) {
        case "add":
          this.releaseNotice();
          break;
        case "edit":
          break;
        case "detail":
          this.sure();
          break;
        default:
          this.$message.error("没有找到页面类型");
          return;
      }
    },
    // 添加考生
    async addMember() {
      this.$refs.addMember.addMemberVisible = true;
      this.$refs.addMember.groupList = this.groupList;
    },
    // 发布公告按钮
    async releaseNotice() {
      console.log("发布公告...");
      let step1 = this.$parent.$children[0].formLabelAlign;
      let step2 = this.allDataIds;
      if (
        !step1.NoticeName ||
        !step1.OpenTime ||
        !step1.OpenTime[0] ||
        !step1.OpenTime[1] ||
        !step1.NoticeContent
      ) {
        this.$message.error("发布公告基本信息填写有误，请检查填写数据");
        return;
      }
      if (!step2.length) {
        this.$message.error("请添加考生后再发布公告");
        return;
      }
      const reqParam = this.baseReqParamUtils(new Object());
      const datas = new Object();
      datas.NoticeName = step1.NoticeName;
      datas.Content = step1.NoticeContent;
      datas.BeginTime = this.$moment(step1.OpenTime[0]).format(
        "YYYY-MM-DD HH:mm"
      );
      datas.EndTime = this.$moment(step1.OpenTime[1]).format(
        "YYYY-MM-DD HH:mm"
      );
      datas.UserIDArr = step2;
      reqParam.data = JSON.stringify(datas);
      console.log(reqParam, "发布公告请求数据");
      const { data } = await noticeApi.addNotice(reqParam);
      console.log(data, "发布公告响应数据");
      if (data.Status == 200) {
        this.sumbitBtnDisable = true;
        this.$message.success("发布公告成功");
        this.$parent.$parent.$children[0].getAllNotice();
        this.$parent.$parent.changes(0);
        this.$parent.backBtn();
      } else {
        this.$message.error(data.Data);
      }
    },
    // 确定按钮
    async sure() {
      this.$parent.$parent.$children[0].getAllNotice();
      this.$parent.$parent.changes(0);
      this.$parent.backBtn();
    },
  },
  filters: {
    sumbitBtnName(value) {
      switch (value) {
        case "add":
          return "发布公告";
        case "edit":
          return "编辑公告";
        case "detail":
          return "确定";
        default:
          return;
      }
    },
  },
  created() {
    this.groupLists();
    this.switchLists();
  },
};
</script>

<style lang='scss' scoped>
// 右边整体iframe的css
.center {
  height: 100%;
  width: 100%;
  // padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}

// 条件筛选框css
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .el-form {
    display: flex;
    ::v-deep .el-form-item__content {
      margin-left: 111px !important;
    }
    ::v-deep .el-input > .el-input__inner {
      width: 168px;
    }
  }
  .query_btn {
    margin: 0;
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
    }
  }
}

// 列表全局按钮css
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  padding: 0px 24px !important;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 104px;
    margin-left: 0px;
    margin-right: 24px;
  }
  .el-button:nth-child(2) {
    background: #e54d4d;
    width: 136px;
    margin-left: 0px;
    margin-right: 24px;
    span > i {
      font-size: 16px !important;
      margin-right: 5px;
    }
  }
}

// 表格内容css
.student_table {
  margin-top: 24px;
  padding: 0px 24px;
}

.operation_box {
  width: 250px;
  text-align: center;
  margin: 0 auto;
  .el-button {
    font-size: 16px;
    margin-left: 0px;
    margin-right: 25px;
  }
}

::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}

// 分页
.foot_box {
  position: relative;
  height: 88px;
  .foot_pagetions {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
    .pagination {
      ::v-deep .el-pager {
        li {
          border: 1px solid #d9d9d9;
          margin-right: 8px;
          &.active {
            color: #ffffff;
            background-color: #409eff;
            border: none;
          }
        }
      }
      ::v-deep .el-pagination__jump {
        margin: 0px 10px 0px 0px !important;
      }
      // ::v-deep .el-pagination__jump {
      //   &::before {
      //     content: "10条/页";
      //     width: 82px;
      //     border: 1px solid #d9d9d9;
      //     height: 28px;
      //     border-radius: 2px;
      //     text-align: center;
      //     display: inline-block;
      //     margin-right: 8px;
      //     cursor: pointer;
      //   }
      // }
    }
  }
}

// 底部按钮
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 50px 0 70px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-input__inner {
  border: 1px solid #dcdfe6;
}

// 底部按钮下的空行
.konghuang {
  height: 50px;
  background-color: #f8f8f8;
}
</style>